import {
  Badge,
  Checkbox,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { dateFilters } from "../centralOms/common/constants";
import BulkActionsDialog from "../centralOms/bulkActionDialog";
import DownloadIcon from "@mui/icons-material/Download";
import { getOrderPackageDetails, getRequiredDocuments } from "../../services/provider/common";
import { MBContract } from "../../constants/insurance/constant";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import { corporateIdsMERFormApplicable, ppmcContracts, STATUS_CODE_MAP, TEST_FOR_HA_CASES } from "../../constants/provider/constant";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import ActionsData from "./actionsData";
import ConfirmRejectAppointment from "./dialogs/confirmReject";
import AttendanceDialog from "./dialogs/attendance";
import SubmitDocumentsDialog from "./dialogs/documentSubmit";
import { EVENTS } from "../centralOms/events_constant";
import { fetchUserDetailsAndSetUserForAnalytics, logEventToAnalyticsPlatform } from "../../helper/events";

export const TableStructure = ({
  orders,
  totalRows,
  page,
  setPage,
  loading,
  exportLoading,
  fetchData,
  setFetchData,
  remarksEnable,
  bulkMarkStatus,
  exportOrderData,
  sortDirection,
  setSortDirection,
  setSortLabel,
  checkSlaOnModifiedDate,
  slaShow,
  fetchHighSLACases,
  setFetchHighSLACases,
  applicableActions,
  addressRequired,
  laterDateFilter,
  showStatus,
  slaField = "createdOn",
  slaHours = 12,
  tabName
}) => {
  const [action, setAction] = useState("");
  const [confirmRejectDialogVisible, setConfirmRejectDialogVisibility] = useState(false);
  const [attendanceDialogVisible, setAttendanceDialogVisibility] = useState(false);
  const dateFilterObject = JSON.parse(sessionStorage.getItem("dateFilterObject"));
  const dateFilterName = dateFilterObject?.name ? dateFilterObject.name : laterDateFilter ? "Next 30 Days" : "Previous 7 Days";
  const [dateFilter, setDateFilter] = useState(dateFilterName);
  const selectedDateFilter = dateFilters.find((elem) => elem.name === dateFilterName);
  const [startDate, setStartDate] = useState(dateFilterObject?.startDate ? dateFilterObject.startDate : selectedDateFilter.startDate);
  const [endDate, setEndDate] = useState(dateFilterObject?.endDate ? dateFilterObject.endDate : selectedDateFilter.endDate);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [docUploadDialogVisible, setDocUploadDialogVisibility] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [bulkActionDialogVisible, setBulkActionDialogVisibility] = useState(false);
  const [actionHeader, setActionHeader] = useState("");
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const childEntities = user_details?.parentProvider?.isParent ? user_details.parentProvider.childEntities : null;
  const [showPackageDetails, setShowPackageDetails] = useState(false);
  const [packageDetails, setPackageDetails] = useState({});
  const [packageName, setPackageName] = useState("");
  const totalRowsToSelect = totalRows && totalRows < 10 ? totalRows : 10;


  useEffect(() => {
    const triggerEvents = async () => {
      await fetchUserDetailsAndSetUserForAnalytics();
      logEventToAnalyticsPlatform({
        name: EVENTS.PC_SCREEN_LANDING.name,
        payload: {
          tab_name: tabName,
          service_type: EVENTS.SERVICE_TYPE_OMS,
          screenName: EVENTS.SERVICE_NAME_LABS,
        },
        schema: EVENTS.PC_SCREEN_LANDING.schema,
      })
    }
    triggerEvents();

  }, [])

  const onDateChange = (selectedValue) => {
    setDateFilter(selectedValue);
    const selectedDateFilter = dateFilters.find((elem) => elem.name === selectedValue);
    if (selectedDateFilter && selectedDateFilter.startDate && selectedDateFilter.endDate) {
      setStartDate(selectedDateFilter.startDate);
      setEndDate(selectedDateFilter.endDate);
      let dateFilterObject = {
        name: selectedValue,
      };
      sessionStorage.setItem("dateFilterObject", JSON.stringify(dateFilterObject));
      setFetchData(!fetchData);
    } else {
      setStartDate("");
      setEndDate("");
    }
  };
  const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth || dateOfBirth === "/Date(-62135596800000-0000)/" || dateOfBirth.match("000")) return "NA";

    const today = new Date();
    const dob = new Date(dateOfBirth);

    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return !Number(age) ? "NA" : age;
  };

  const handleChangePage = (event, newPage) => {
    setFetchData(!fetchData);
    setPage(newPage);
  };

  const getPackageDetails = (orderItemProductIds, packageName) => {
    setPackageName(packageName);
    setShowPackageDetails(true);
    let data = orderItemProductIds.split(",").map((ele) => parseInt(ele));
    getOrderPackageDetails(data).then((data) => {
      let obj = {};
      if (data.isSuccess) {
        data.packagesTests.map((ele) => {
          const tests = ele.tests.map((el) => {
            return el.name;
          });
          if(obj[ele.groupName]) {
            obj[ele.groupName] = obj[ele.groupName].concat(tests);
          } else {
            obj[ele.groupName] = tests;
          };
        });
        setPackageDetails(obj);
      } else {
        setPackageDetails({});
      }
    });
  };

  const getReports = (order) => {
    getRequiredDocuments(
      order.primaryEntityId,
      order.primaryEntityName,
      TEST_FOR_HA_CASES.includes(order.testCategory?.toLowerCase() ?? order.packageName.toLowerCase()) && order.primaryEntityId === 177310
    ).then((res) => {
      if (res) {
        console.log(res);
      }
    });
  };

  const handleClickSearch = () => {
    let dateFilterObject = {
      name: dateFilter,
      startDate: startDate,
      endDate: endDate,
    };
    sessionStorage.setItem("dateFilterObject", JSON.stringify(dateFilterObject));
    setFetchData(!fetchData);
    logEventToAnalyticsPlatform({
      name: EVENTS.PC_LS_ACTION.name,
      payload: {
        tab_name: EVENTS.TAB_NAME_UPCOMING_APPOINTMENTS,
        filterValue: 'true',
        reference_id: '',
        reference_provider_id: '',
        service_name: EVENTS.SERVICE_NAME_LABS,
        action: EVENTS.ACTION.SEARCH_ICON_CLICKED,
      },
      schema: EVENTS.PC_LS_ACTION.schema,
    })
  };

  const handleCheckboxClick = (requestId) => {
    const ids = [...selectedIds];
    if (ids.includes(requestId)) {
      ids.splice(ids.indexOf(requestId), 1);
    } else {
      ids.push(requestId);
    }
    setSelectedIds(ids);
  };

  const handleSelectAllClick = (evt) => {
    if (evt.target.checked) {
      if (bulkMarkStatus == "Attended") {
        setSelectedIds(orders.filter((elem) => elem.statusID == STATUS_CODE_MAP["Customer awaited at DC"]).map((elem) => elem.id));
      } else {
        setSelectedIds(orders.map((elem) => elem.id));
      }
    } else {
      setSelectedIds([]);
    }
  };

  const bulkConfirmClick = () => {
    setAction("Confirm");
    setActionHeader("Bulk Confirm");
    setBulkActionDialogVisibility(true);
  };

  const bulkAttendClick = () => {
    setAction("Attended");
    setActionHeader("Bulk Mark Attended");
    setBulkActionDialogVisibility(true);
  };

  const handleRequestSort = (sortLabel) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSortLabel(sortLabel);
    setFetchData(!fetchData);
  };

  const handleClickHighSla = (elem) => {
    setFetchHighSLACases(elem);
    setFetchData(!fetchData);
  };

  const headCells = [
    {
      id: "requestid",
      label: "Request ID/ Member ID",
      sortEnabled: false,
    },
    {
      id: "customername",
      label: "Customer Details",
      sortEnabled: false,
    },
    {
      id: "contactno",
      label: addressRequired ? "Address/ Contact No." : "Contact No.",
      sortEnabled: false,
    },
    {
      id: "package",
      label: "Package Details",
      sortEnabled: false,
    },
    {
      id: "appointmentdate",
      label: "Appointment Date & Time",
      sortEnabled: true,
      sortLabel: "FulfillmentDate",
    },
    {
      id: "samplereports",
      label: "Download Sample Reports",
      sortEnabled: false,
    },
    {
      id: "providername",
      label: "Provider Name",
      sortEnabled: false,
    },
    {
      id: "contract",
      label: "Corporate/ PPMC",
      sortEnabled: false,
    },
  ];
  if (remarksEnable) {
    headCells.push({
      id: "remarks",
      label: "Remarks",
    });
  }
  if (showStatus) {
    headCells.push({
      id: "status",
      label: "Status",
    });
  }
  headCells.push({
    id: "additionals",
    label: "Actions",
  });

  return (
    <>
      <div className="flex w-full justify-between pb-4 px-4">
        <div className="flex date-filter-dashboard">
          <FormControl sx={{ width: 140 }} size="small">
            <InputLabel id="dateFilter">Appointment Date</InputLabel>
            <Select
              labelId="dateFilter"
              name="dateFilter"
              id="dateFilter"
              value={dateFilter}
              label="Appointment Date"
              onChange={(event) => {
                onDateChange(event.target.value);
              }}
            >
              {dateFilters.map((elem) => (
                <MenuItem value={elem.name}>{elem.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className="ml-2">
            <TextField
              className="w-full"
              id="date"
              label="Start Date"
              type="date"
              value={startDate ? startDate : ""}
              onChange={(evt) => setStartDate(evt.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={dateFilter === "Custom" ? false : true}
            />
          </div>
          <div className="ml-2">
            <TextField
              className="w-full"
              id="date"
              label="End Date"
              type="date"
              value={endDate ? endDate : ""}
              onChange={(evt) => setEndDate(evt.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              disabled={dateFilter === "Custom" ? false : true}
            />
          </div>
          <div className="ml-2 search-icon">
            <div className="w-full">
              <div className="m-auto">
                <SearchIcon onClick={() => handleClickSearch()} />
              </div>
            </div>
          </div>
        </div>
        <div className="m-auto">
          <div className="w-full flex text-center text-xs">
            {slaShow && (
              <div className="flex">
                <div
                  className={
                    fetchHighSLACases
                      ? "mr-hr-xs-0 border-2 border-blue-500 text-gray-900 font-semibold text-center rounded-3xl shadow-inner text-xs cursor-pointer mx-2 h-full"
                      : "mr-hr-xs-0 border-2 border-gray-200 text-gray-900 font-semibold text-center rounded-3xl shadow-sm text-xs cursor-pointer mx-2 h-full"
                  }
                  key="highSla"
                  onClick={() => handleClickHighSla(true)}
                >
                  <div className="p-2 px-8">
                    <span className="mr-2">Priority Cases</span>
                    {fetchHighSLACases && !loading && (
                      <span className="text-gray-100 font-semibold rounded-3xl p-1 bg-red-500" style={{ fontSize: "10px" }}>
                        {totalRows > 9 ? totalRows : "0" + totalRows}
                      </span>
                    )}
                  </div>
                </div>
                <div
                  className={
                    !fetchHighSLACases
                      ? "mr-hr-xs-0 border-2 border-blue-500 text-gray-900 font-semibold text-center rounded-3xl shadow-inner text-xs cursor-pointer mx-2 h-full"
                      : "mr-hr-xs-0 border-2 border-gray-200 text-gray-900 font-semibold text-center rounded-3xl shadow-sm text-xs cursor-pointer mx-2 h-full"
                  }
                  key="total"
                  onClick={() => handleClickHighSla(false)}
                >
                  <div className="p-2 px-8">
                    <span className="mr-2">Total Cases</span>
                    {!fetchHighSLACases && !loading && (
                      <span className="text-gray-100 font-semibold rounded-3xl p-1 bg-green-500" style={{ fontSize: "10px" }}>
                        {totalRows > 9 ? totalRows : "0" + totalRows}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="flex">
          {bulkMarkStatus === "Confirm" && (
            <>
              {selectedIds && selectedIds.length > 1 ? (
                <div className="my-auto" onClick={() => bulkConfirmClick()}>
                  <Badge badgeContent={selectedIds.length} color="primary">
                    <span className="bg-blue-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer m-auto">
                      Bulk Confirm
                    </span>
                  </Badge>
                </div>
              ) : (
                <div className="bg-gray-200 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-disabled my-auto">
                  Bulk Confirm
                </div>
              )}
            </>
          )}
          {bulkMarkStatus == "Attended" && (
            <>
              {selectedIds && selectedIds.length > 1 ? (
                <div className="my-auto" onClick={() => bulkAttendClick()}>
                  <Badge badgeContent={selectedIds.length} color="primary">
                    <span className="bg-blue-100 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-pointer my-auto">
                      Bulk Attend
                    </span>
                  </Badge>
                </div>
              ) : (
                <div className="bg-gray-200 text-gray-900 font-semibold border text-center rounded-md py-2 px-3 text-xs cursor-disabled my-auto">
                  Bulk Attend
                </div>
              )}
            </>
          )}
          <button
            className={
              exportLoading
                ? "border border-gray-400  hover:bg-gray-600 hover:border-gray-600 hover:text-gray-100 text-gray-900 font-semibold text-center rounded-md py-2 px-3 text-xs cursor-default ml-2 my-auto"
                : "border border-blue-400  hover:bg-blue-600 hover:border-blue-600 hover:text-gray-100 text-gray-900 font-semibold text-center rounded-md py-2 px-3 text-xs cursor-pointer ml-2 my-auto"
            }
            onClick={() => exportOrderData()}
            disabled={exportLoading}
          >
            Export
            <span className="pl-1 font-svg-xxs">
              <DownloadIcon></DownloadIcon>
            </span>
          </button>
        </div>
      </div>

      <div className="appointment-wrapper">
        {loading ? <LinearProgress /> : <div className="h-1"></div>}
        <TableContainer>
          <Table sx={{ minWidth: 750 }} className="text-sm" aria-labelledby="tableTitle" size={"medium"}>
            <TableHead>
              <TableRow className="bg-gray-100">
                {bulkMarkStatus && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      indeterminate={selectedIds.length > 0 && selectedIds.length < totalRowsToSelect}
                      checked={totalRowsToSelect > 0 && selectedIds.length === totalRowsToSelect}
                      onChange={(evt) => handleSelectAllClick(evt)}
                      inputProps={{
                        "aria-label": "select all desserts",
                      }}
                    />
                  </TableCell>
                )}
                {headCells.map((headCell) => (
                  <TableCell key={headCell.id} align="left" padding="normal">
                    {headCell.sortEnabled ? (
                      <TableSortLabel direction={sortDirection} onClick={() => handleRequestSort(headCell.sortLabel)}>
                        <span className="font-bold text-xs">{headCell.label}</span>
                      </TableSortLabel>
                    ) : (
                      <span className="font-bold text-xs">{headCell.label}</span>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {orders?.length > 0
                ? orders.map((order, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    const isItemSelected = selectedIds.includes(order.id);
                    return (
                      <TableRow
                        hover
                        // role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={order.id}
                        selected={isItemSelected}
                        className="bg-white"
                      >
                        {bulkMarkStatus && (
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              onClick={(event) => handleCheckboxClick(order.id)}
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                              disabled={bulkMarkStatus == "Attended" && order.statusID != STATUS_CODE_MAP["Customer awaited at DC"]}
                            />
                          </TableCell>
                        )}
                        <TableCell align="left" component="th" id={labelId} scope="row">
                          <div className="text-gray-500">{order.id}</div>
                          <div className="text-gray-500 text-xs">{order.employeeId}</div>
                        </TableCell>
                        <TableCell align="left">
                          <strong>{order.patientName}</strong>
                          <div className="text-gray-500 text-xs">Age: {calculateAge(order.dob ?? "")}</div>
                          <div className="text-gray-500 text-xs">Gender: {order.gender}</div>
                          <div className="text-gray-500 text-xs">{order.primaryEntityName}</div>
                        </TableCell>
                        <TableCell align="left">
                          {addressRequired && <div className="text-xs">{order.addressLine1}</div>}
                          <div className="text-gray-500 text-xs">{order.phone}</div>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="cursor-pointer"
                          style={{ maxWidth: "15vw" }}
                          onClick={() =>
                            getPackageDetails(
                              order.orderItemProductIds ? order.orderItemProductIds : String(order.orderItemProductId),
                              order.packageName
                            )
                          }
                        >
                          <div className="text-xs text-blue-600 w-full truncate font-medium">{order.packageName}</div>
                        </TableCell>
                        <TableCell align="left">
                          <div className="text-xs">
                            {moment(order.fulfillmentDate).format("MMMM Do YYYY")}
                            <div className="text-gray-500 text-xs">{moment(order.fulfillmentDate).format("hh:mm A")}</div>
                          </div>
                        </TableCell>
                        <TableCell align="left">
                          <div className="text-xs flex justify-left">
                            <div className="mx-1 text-yellow-700 cursor-pointer">
                              {([MBContract["ESALES"], MBContract["PrePolicy"]].includes(order.contractId) ||
                                corporateIdsMERFormApplicable.includes(order.primaryEntityId)) && (
                                <Tooltip title="Document Download" placement="bottom-end">
                                  <GetAppRoundedIcon
                                    onClick={() => {
                                      getReports(order);
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell align="left">
                          {childEntities ? (
                            <div className="text-xs">{childEntities[order.currentProvider]}</div>
                          ) : (
                            <div className="text-xs">{order.providerName}</div>
                          )}
                        </TableCell>
                        <TableCell align="left">
                          <div className="text-xs">{ppmcContracts.includes(order.contractId) ? "PPMC" : "Corporate"}</div>
                        </TableCell>
                        {remarksEnable && (
                          <TableCell align="left">
                            {order.statusID === STATUS_CODE_MAP["Information Awaited"] && (
                              <>
                                <div className="bg-red-300 text-gray-900 rounded p-2 text-center w-auto text-xs font-semibold">QC Rejected</div>
                                <div className="text-xs">{order.remarks ? order.remarks : "No Remarks"}</div>
                              </>
                            )}
                          </TableCell>
                        )}
                        {showStatus && (
                          <TableCell align="left">
                            <div className="text-xs text-gray-500">{order.displayStatus}</div>
                          </TableCell>
                        )}
                        <TableCell align="left">
                          <ActionsData
                            nextActions={order.nextActions}
                            currentOrder={order}
                            setConfirmRejectDialogVisibility={setConfirmRejectDialogVisibility}
                            setAttendanceDialogVisibility={setAttendanceDialogVisibility}
                            setDocUploadDialogVisibility={setDocUploadDialogVisibility}
                            setAction={setAction}
                            checkSlaOnModifiedDate={checkSlaOnModifiedDate}
                            setCurrentOrder={setCurrentOrder}
                            allowedActions={applicableActions}
                            slaField={slaField}
                            slaHours={slaHours}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack spacing={2} className="p-2">
          <div className="flex justify-between">
            <div className="pt-2">
              {orders?.length > 0 && (
                <div>
                  <span className="text-gray-400 text-sm">Total Counts :</span>
                  <span className="text-gray-400 pl-2 font-semibold text-sm">{totalRows}</span>
                </div>
              )}
            </div>

            <div>
              <Pagination
                count={Math.ceil(totalRows / 10)}
                boundaryCount={4}
                showFirstButton={true}
                showLastButton={true}
                page={page}
                onChange={handleChangePage}
              />
            </div>
          </div>
        </Stack>
      </div>
      {confirmRejectDialogVisible && (
        <ConfirmRejectAppointment
          action={action}
          requestDetails={currentOrder}
          confirmRejectDialogVisible={confirmRejectDialogVisible}
          setConfirmRejectDialogVisibility={setConfirmRejectDialogVisibility}
          fetchData={fetchData}
          setFetchData={setFetchData}
        ></ConfirmRejectAppointment>
      )}
      {attendanceDialogVisible && (
        <AttendanceDialog
          action={action}
          requestDetails={currentOrder}
          attendanceDialogVisible={attendanceDialogVisible}
          setAttendanceDialogVisibility={setAttendanceDialogVisibility}
          fetchData={fetchData}
          setFetchData={setFetchData}
        ></AttendanceDialog>
      )}
      {docUploadDialogVisible && (
        <SubmitDocumentsDialog
          action={action}
          requestDetails={currentOrder}
          documentDialogVisible={docUploadDialogVisible}
          setDocumentDialogVisibility={setDocUploadDialogVisibility}
          fetchData={fetchData}
          setFetchData={setFetchData}
        ></SubmitDocumentsDialog>
      )}
      {bulkActionDialogVisible && (
        <BulkActionsDialog
          action={action}
          actionHeader={actionHeader}
          bulkActionDialogVisible={bulkActionDialogVisible}
          setBulkActionDialogVisibility={setBulkActionDialogVisibility}
          requestIds={selectedIds}
          fetchData={fetchData}
          setFetchData={setFetchData}
          setSelectedIds={setSelectedIds}
          service={["LABS"]}
        ></BulkActionsDialog>
      )}
      <Dialog
        fullWidth={true}
        maxWidth={"xs"}
        open={showPackageDetails}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setShowPackageDetails(false);
            setPackageDetails({});
            setPackageName("");
          } else return false;
        }}
      >
        <DialogTitle style={{ background: "rgb(245 245 245)" }}>
          <div className="flex">
            <div>{packageName}</div>
          </div>
        </DialogTitle>
        <DialogContent id="packagePopUp">
          <div>
            {packageDetails &&
              packageDetails != {} &&
              Object.keys(packageDetails).map((ele, i) => {
                return (
                  <div className="p-2 mb-3 ">
                    <p className="font-semibold text-gray-700 ">
                      {i + 1}. {ele}
                    </p>
                    <div className="ml-6">{ele && packageDetails[ele] && packageDetails[ele].map((e) => <p className="text-sm">{e}</p>)}</div>
                  </div>
                );
              })}
            {(!packageDetails || Object.keys(packageDetails).length == 0) && <div>{packageName}</div>}
          </div>
        </DialogContent>
        <DialogActions style={{ background: "rgb(245 245 245)" }}>
          <Button
            onClick={() => {
              setShowPackageDetails(false);
              setPackageDetails({});
              setPackageName("");
            }}
            color="primary"
            variant="outlined"
          >
            close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
